import type { ISaveEnergyPassportParams } from "@/entities/energy-passport/types.ts"
import type { IResponse } from "@/shared/types"
import { requestIntensity } from "@/shared/utils/axios.ts"

export const saveEnergyPassport = async ({ contractId, year }: ISaveEnergyPassportParams, body: object) => {
  const { data } = await requestIntensity.post(`/passports/${contractId}/${year}/`, body)
  return data as IResponse<object>
}
